import { Routes } from '@angular/router';
import { GermplasmNamePopupComponent } from './germplasm-name-modal.component';

export const GERMPLASM_NAME_ROUTES: Routes = [
    {
        path: 'germplasm-name-dialog/:gid',
        component: GermplasmNamePopupComponent,
        outlet: 'popup'
    }
];
